import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Tooltip } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { sortPrescriptionParameters, PrescriptionValueUtils } from '@grandvisionhq/utils';
import { isPrescriptionValue } from '../../../../../state/types.js';

const getOptions = (values, prescriptionAttribute)=>{
    const formatter = PrescriptionValueUtils.getFormatter(prescriptionAttribute);
    return Array.from(values).reduce((acc, value)=>{
        const formattedValue = formatter(value);
        if (formattedValue) {
            return swcHelpers.objectSpread({}, acc, {
                [formattedValue]: value
            });
        } else {
            console.error(`Error formatting prescription value ${value} for attribute: ${prescriptionAttribute}`);
            return acc;
        }
    }, {});
};
const PrescriptionSelect = /*#__PURE__*/ React.memo(({ name , parentId , values , selectClassName , onChange , errorMessageId , value , isValid , isDisabled ,  })=>{
    const { getLabel  } = useIntl();
    const isDesktop = MediaQuery.useIsDesktop();
    const options = React.useMemo(()=>getOptions(values, name)
    , [
        values,
        name
    ]);
    const sortOptions = React.useCallback((a, b)=>Number(a) - Number(b)
    , []);
    var ref;
    const formattedValue = (ref = PrescriptionValueUtils.formatPrescriptionValue(name, value)) !== null && ref !== void 0 ? ref : '';
    const valueAsString = React.useMemo(()=>({
            value: isPrescriptionValue(value) && values.has(value) ? formattedValue : ''
        })
    , [
        values,
        value,
        formattedValue
    ]);
    const { selectId , labelId , selectName  } = React.useMemo(()=>({
            selectId: `${parentId}-${name}-select`,
            labelId: `${parentId}-${name}-label`,
            selectName: `prescription-select-${name}`
        })
    , [
        parentId,
        name
    ]);
    const handleChange = React.useCallback((newValue)=>{
        onChange(name, newValue);
    }, [
        onChange,
        name
    ]);
    const isInvalid = isValid === false;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "prescription-column__label-wrapper"
    }, /*#__PURE__*/ React.createElement("label", {
        id: labelId,
        htmlFor: selectId,
        className: "prescription-column__label"
    }, getLabel(`products.glasses.prescription.${name}`)), /*#__PURE__*/ React.createElement(Tooltip, {
        id: `${parentId}-${name}-tooltip`,
        greyedOut: isDisabled,
        className: "prescription-column__tooltip",
        message: getLabel(`products.glasses.prescription.${name}.tooltip`),
        boundariesElement: isDesktop ? 'window' : 'scrollParent'
    })), /*#__PURE__*/ React.createElement(Select, {
        id: selectId,
        "aria-labelledby": `${labelId} ${parentId}`,
        "aria-describedby": errorMessageId,
        "aria-invalid": isInvalid,
        className: classnames('prescription-column__select', selectClassName),
        options: options,
        sortOptionsBy: sortOptions,
        initialState: valueAsString,
        onChange: handleChange,
        name: selectName,
        "data-t": selectName,
        placeholder: "---"
    }));
});
const PrescriptionColumn = (_param)=>{
    var { id , className , hideSelectLabels , columnTitle , errorMessageId , parameters , selectedValues , validations , showValidation , onAttributeChange , isDisabled  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "id",
        "className",
        "hideSelectLabels",
        "columnTitle",
        "errorMessageId",
        "parameters",
        "selectedValues",
        "validations",
        "showValidation",
        "onAttributeChange",
        "isDisabled"
    ]);
    const sortedParams = sortPrescriptionParameters(parameters.map((p)=>p.name
    ));
    return /*#__PURE__*/ React.createElement("fieldset", {
        "data-t": "prescription-column-fieldset",
        disabled: isDisabled,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        "data-t": rest['data-t'],
        className: classnames('prescription-column', {
            'prescription-column--hide-labels': hideSelectLabels,
            'prescription-column--disabled': isDisabled
        })
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "subheading2",
        id: id,
        className: "prescription-column__title"
    }, columnTitle), sortedParams.map((paramName, index, array)=>{
        const parameter = parameters.find((p)=>p.name === paramName
        );
        if (!parameter) {
            return;
        }
        const parameterValue = selectedValues[parameter.name];
        const isParameterValid = showValidation ? validations === null || validations === void 0 ? void 0 : validations[parameter.name] : undefined;
        return /*#__PURE__*/ React.createElement(PrescriptionSelect, {
            key: parameter.name,
            name: parameter.name,
            parentId: id,
            value: !isDisabled ? parameterValue : undefined,
            isValid: isParameterValid,
            isDisabled: isDisabled,
            values: parameter.values,
            onChange: onAttributeChange,
            selectClassName: classnames({
                'prescription-column__select--first': index === 0,
                'prescription-column__select--last': index === array.length - 1
            })
        });
    })));
};
var PrescriptionColumn$1 = /*#__PURE__*/ React.memo(PrescriptionColumn);

export { PrescriptionColumn$1 as default };
//# sourceMappingURL=PrescriptionColumn.js.map
